<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>회원가입안내 등록</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <!-- <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">노출여부</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group id="basicCustomUseyn" name="useyn">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="useY" name="useyn" class="custom-control-input" v-model="queryParams.use_yn" value="Y" checked>
                            <label class="custom-control-label" for="useY">노출</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="useN" name="useyn" class="custom-control-input" v-model="queryParams.use_yn" value="N">
                            <label class="custom-control-label" for="useN">비노출</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                  </tr> -->
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">제목</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" name="title" type="text" v-model="queryParams.title" v-validate="'required'" :class="{'is-invalid': errors.has('title')}"></b-form-input>
                            <span v-show="errors.has('title')" :class="{error: errors.has('title')}">제목명은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">내용</label>
                      </td>
                      <td class="">
                        <textarea id="summernote"></textarea>
                      </td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                </b-col>
                <b-col md="4">
                  <b-button variant="success" v-on:click="saveJoinGuideData()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/customer/joinguide'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue';
import datetimepicker from "daterangepicker/daterangepicker.js";
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Summernote from 'summernote/dist/summernote-bs4.js'
import SummernoteLang from 'summernote/dist/lang/summernote-ko-KR.js'
import 'bootstrap'
import { codeAPI } from '../../common/code.js';

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    Summernote,
  },
  data() {
    return {
      joinGuideCode: '',
      pageOptions: [5, 10, 30, 50, 100],
      formtype: '',
      queryParams: {
        // reg_date: moment().format('YYYY-MM-DD'),
        use_yn: 'Y',
      },
      // endDate: moment().format('YYYY-MM-DD'),
      // startDate: moment().format('YYYY-MM-DD'),
      enabled: true,
    }
  },
  watch: {
  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;

    self.formtype = self.$route.query.status;
    self.joinGuideCode = self.$session.get('joinGuideCode');

    if(self.formtype == 'update'){
      self.getJoinGuideData(self.joinGuideCode);
    }

    $('#summernote').summernote({
      height: 300, //에디터 높이
      minHeight: null, //최소 높이
      maxHeight: null, //최대 높이
      focus: false, //에디터 로딩 후 포커스를 맞출지 여부
      lang: "ko-KR", // 한글 설정
      // placeholder: '최대 2048자까지 쓸 수 있습니다', //placeholder 설정
      callbacks: {	//여기 부분이 이미지를 첨부하는 부분
					onImageUpload : function(files) {
            self.uploadSummernoteImageFile(files[0],this);
					},
					onChange: function(contents, $editable) {
            self.queryParams.contents = contents;
          }
			  }
    });

    setTimeout(function() {
      var code = $('#summernote').summernote('code');
      if (code.startsWith('<p><br></p>')) {
        code = code.substring('<p><br></p>'.length);
        $('#summernote').summernote('code', code);
      }
    }, 400);

  },
  methods: {
    // 회원가입안내 데이터 조회
    getJoinGuideData(joinGuideCode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/joinGuideData?access_token=' + token + '&joinGuideCode=' + joinGuideCode)
      .then((result) => {
        self.queryParams = result.data;
        $('#summernote').summernote('pasteHTML', result.data.contents);
      })
    },
    // 회원가입안내 데이터 저장
    saveJoinGuideData() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");
          self.queryParams.reg_id = self.$session.get('userId');

          if(self.queryParams.contents == ""){
            swal.fire({
              type: 'warning',
              title: '내용 부분은 필수로 작성해 주세요.',
              showConfirmButton: true,
            })
            return false;
          }

          // console.log(self.queryParams);
          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('objs', param);

          if(self.formtype == 'insert'){
            self.$http.post('/api/insert/joinGuideData?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '회원가입안내이 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                    window.location = "#/customer/joinguide";
                });
            })
          }else if(self.formtype == 'update'){
            self.$http.post('/api/update/joinGuideData?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '회원가입안내을 수정하였습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                    window.location = "#/customer/joinguide";
                });
            })
          }
        }
      })
    },
    /**
    * 이미지 파일 업로드
    */
    uploadSummernoteImageFile(file, editor) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var data = new FormData();
      data.append("file", file);

      self.$http.post('/ftpserver/editorImageUpload?access_token='+token, data, null)
      .then((result) => {
        $(editor).summernote('insertImage', result.data);
      })
    },
  }
}

</script>
<style lang="css" scoped>
span.error {
  color: #9F3A38;
}
</style>



// WEBPACK FOOTER //
// src/views/customer/JoinGuideForm.vue